"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketsHolder = (function () {
    function TicketsHolder() {
        this.tickets = [];
        this.allowWinnerPromote = false;
    }
    TicketsHolder.prototype.clearTickets = function () {
        this.tickets = [];
        this.allowWinnerPromote = false;
        var holderDiv = document.getElementById('ticketsScroll');
        if (holderDiv !== null) {
            holderDiv.innerHTML = '';
            holderDiv.innerHTML = '<div id="winningDelimiter"></div>';
        }
    };
    TicketsHolder.prototype.addTicket = function (ticket) {
        this.tickets.push(ticket);
    };
    TicketsHolder.prototype.setAllowWinnerPromote = function (allow) {
        this.allowWinnerPromote = allow;
    };
    TicketsHolder.prototype.showTickets = function () {
        this.allowWinnerPromote = false;
        var self = this;
        for (var key in this.tickets) {
            $("#ticketsScroll").append(this.tickets[key].getHTML(Number(key)));
        }
        $('.ticket-share-image').on('click', function () {
            $('#ticket-share-confirm' + this.dataset.sharekey).css('display', 'flex');
        });
        $('.shareConfirmNo').on('click', function () {
            $('#ticket-share-confirm' + this.dataset.sharekey).css('display', 'none');
        });
        setTimeout(function () {
            self.updateTickets();
            var ticketsEvent = new CustomEvent('tickets-present');
            window.dispatchEvent(ticketsEvent);
        }, 250);
        $('.shareConfirmYes').on('click', function () {
            var tempKey = this.dataset.sharekey;
            $('#ticket-share-confirm' + tempKey).css('display', 'none');
            var ticketEvent = new CustomEvent('getTicket', {
                bubbles: true,
                detail: {
                    winStatus: self.tickets[(Number(tempKey))].getWinStatus(),
                    drawnNumbers: self.tickets[(Number(tempKey))].getDrawnNumbers(),
                    ticketId: self.tickets[(Number(tempKey))].ticketID,
                    sharedData: self.tickets[Number(tempKey)].getSharedWinsData(),
                    ticketHTML: self.tickets[Number(tempKey)].shareHTML()
                }
            });
            window.dispatchEvent(ticketEvent);
        });
    };
    TicketsHolder.prototype.updateTickets = function () {
        for (var key in this.tickets) {
            this.tickets[key].update();
        }
    };
    TicketsHolder.prototype.clearDrawMarks = function () {
        for (var key in this.tickets) {
            this.tickets[key].clearDrawMarks();
        }
    };
    TicketsHolder.prototype.markWinningTicket = function (ticketID) {
        var $ticket = $('#ticket-' + ticketID);
        if (!$ticket.length) {
            return;
        }
        $ticket.removeClass('active-ticket lost-ticket').addClass('winning-ticket');
        $('#shareButton-' + ticketID).addClass('showShare');
        if (this.allowWinnerPromote) {
            $('#winningDelimiter').append($ticket);
        }
    };
    return TicketsHolder;
}());
exports.default = TicketsHolder;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/tickets-holder.ts
// module id = 1207
// module chunks = 0